import React from "react";

import { Section } from "@/components/Section";
import { Collapsible } from "@/eworkitComponents";

import "./_filters-collapsible.scss";

interface IFiltersCollapsibleProps {
  collapsed?: boolean;
  appearance?: "desktop" | "mobile";
}

const ANIMATIONS_VARIANTS = {
  open: { height: "auto", opacity: 1, overflow: "unset" },
  collapsed: { height: 0, opacity: 0, overflow: "hidden" },
};

export const FiltersCollapsible: React.FC<IFiltersCollapsibleProps> = ({
  children,
  collapsed,
  appearance = "desktop",
}) => {
  return (
    <Collapsible className="filters-collapsible" collapsed={collapsed} variants={ANIMATIONS_VARIANTS}>
      <Section
        shadow={appearance === "mobile" ? "none" : "default"}
        className="filters-collapsible__more-filters"
        borderRadius={appearance === "desktop"}
        margin={appearance === "mobile" ? undefined : ["sm", false, false, false]}>
        {children}
      </Section>
    </Collapsible>
  );
};
